// extracted by extract-css-chunks-webpack-plugin
module.exports = {"backButton":"_1JH4_-","button":"_2eu-Q1","closeButton":"_2yI1UZ","content":"_3PU54N","navContainer":"_35PVKP"};